import { Offer, Option } from 'modules/shared-menu/pages/SharedMenuEditorPage/types';
import { SelectionCategory } from 'modules/shared-menu/types';

export const offerSample: Offer[] = [
  {
    id: 'EXAMPLE_OFFER_ONE',
    name: [
      {
        lang: 'en',
        value: 'EXAMPLE_OFFER_ONE',
        verified: true,
      },
    ],
    scope: {
      id: 'SCOPE',
      type: 'selection',
    },
    version: {
      author: {
        id: 'OFFERING_TEAM',
        kind: 'other',
      },
      created_at: { $date: 1691679028 },
      number: 1,
    },
    caffeine_content: null,
    delivery_methods: ['takeaway'],
    brand_id: undefined,
    enabled: {
      enabled: true,
    },
    price: 1,
    vat_percentage: 14,
    alcohol_percentage: 0,
    courier_restrictions: [],
    description: [
      {
        lang: 'en',
        value: 'the description of the offer',
        verified: true,
      },
    ],
    images: [],
    is_bundle_offer: true,
    vat_category_code: 'FIN-3',
    wolt_plus_only: false,
    barcode_gtin: undefined,
    dietary_preferences: undefined,
    display_unit: undefined,
    external_id: undefined,
    inventory_mode: undefined,
    mandatory_warnings: [],
    max_quantity_per_purchase: undefined,
    min_quantity_per_purchase: undefined,
    merchant_sku: undefined,
    number_of_units: undefined,
    nutrition_values: [],
    nutrition_values_baseline: undefined,
    product_family_id: undefined,
    product_hierarchy_level_id: undefined,
    sell_by_weight_config: undefined,
    user_requirements: undefined,
    volume_in_ml: undefined,
    weekly_availability: undefined,
    weekly_visibility: undefined,
    weight_in_grams: undefined,
  },
  {
    id: 'EXAMPLE_OFFER_TWO',
    name: [
      {
        lang: 'en',
        value: 'EXAMPLE_OFFER_TWO',
        verified: true,
      },
    ],
    scope: {
      id: 'SCOPE',
      type: 'selection',
    },
    version: {
      author: {
        id: 'OFFERING_TEAM',
        kind: 'other',
      },
      created_at: { $date: 1691679028 },
      number: 1,
    },
    caffeine_content: null,
    delivery_methods: ['takeaway'],
    brand_id: undefined,
    enabled: {
      enabled: true,
    },
    price: 1,
    vat_percentage: 14,
    alcohol_percentage: 0,
    courier_restrictions: [],
    description: [
      {
        lang: 'en',
        value: 'the description of the offer',
        verified: true,
      },
    ],
    images: [
      {
        url: 'https://image-resizer-proxy.development.dev.woltapi.com/wolt-dev-development-restaurant-api-menu-images/menu-images/shared/0eca0c9a-9e83-11ee-8b9a-f21ba5186a86_c930951a_5ec6_11ee_8247_4ea0a045ce98_shutterstock_1606944469.jpg',
      },
    ],
    is_bundle_offer: true,
    vat_category_code: 'FIN-3',
    wolt_plus_only: false,
    barcode_gtin: undefined,
    dietary_preferences: undefined,
    display_unit: undefined,
    external_id: undefined,
    inventory_mode: undefined,
    mandatory_warnings: [],
    max_quantity_per_purchase: undefined,
    min_quantity_per_purchase: undefined,
    merchant_sku: undefined,
    number_of_units: undefined,
    nutrition_values: [],
    nutrition_values_baseline: undefined,
    product_family_id: undefined,
    product_hierarchy_level_id: undefined,
    sell_by_weight_config: undefined,
    user_requirements: undefined,
    volume_in_ml: undefined,
    weekly_availability: undefined,
    weekly_visibility: undefined,
    weight_in_grams: undefined,
  },
  {
    id: 'EXAMPLE_OFFER_THREE',
    name: [
      {
        lang: 'en',
        value: 'EXAMPLE_OFFER_THREE',
        verified: true,
      },
    ],
    scope: {
      id: 'SCOPE',
      type: 'selection',
    },
    version: {
      author: {
        id: 'OFFERING_TEAM',
        kind: 'other',
      },
      created_at: { $date: 1691679028 },
      number: 1,
    },
    caffeine_content: null,
    delivery_methods: ['takeaway'],
    brand_id: undefined,
    enabled: {
      enabled: true,
    },
    price: 1,
    vat_percentage: 14,
    alcohol_percentage: 0,
    courier_restrictions: [],
    description: [
      {
        lang: 'en',
        value: 'the description of the offer',
        verified: true,
      },
    ],
    images: [
      {
        url: 'https://image-resizer-proxy.development.dev.woltapi.com/wolt-dev-development-restaurant-api-menu-images/menu-images/shared/8cd34124-a95a-11ee-b17e-9ad8a47124d8__0.jpeg',
      },
      {
        url: 'https://image-resizer-proxy.development.dev.woltapi.com/wolt-dev-development-restaurant-api-menu-images/menu-images/shared/8ce914c2-a95a-11ee-b10d-ba77294d88e5__1.jpeg',
      },
    ],
    is_bundle_offer: true,
    vat_category_code: 'FIN-3',
    wolt_plus_only: false,
    barcode_gtin: undefined,
    dietary_preferences: undefined,
    display_unit: undefined,
    external_id: undefined,
    inventory_mode: undefined,
    mandatory_warnings: [],
    max_quantity_per_purchase: undefined,
    min_quantity_per_purchase: undefined,
    merchant_sku: undefined,
    number_of_units: undefined,
    nutrition_values: [],
    nutrition_values_baseline: undefined,
    product_family_id: undefined,
    product_hierarchy_level_id: undefined,
    sell_by_weight_config: undefined,
    user_requirements: undefined,
    volume_in_ml: undefined,
    weekly_availability: undefined,
    weekly_visibility: undefined,
    weight_in_grams: undefined,
  },
];

export const optionSample: Option[] = [
  {
    id: 'EXAMPLE_OPTION_ONE',
    name: [
      {
        lang: 'en',
        value: 'EXAMPLE_OPTION_ONE',
        verified: true,
      },
    ],
    scope: {
      id: 'SCOPE',
      type: 'selection',
    },
    version: {
      author: {
        id: 'OFFERING_TEAM',
        kind: 'other',
      },
      created_at: { $date: 1691679028 },
      number: 1,
    },
    default_value_index: 0,
    type: 'choice',
    external_id: undefined,
    values: [
      {
        enabled: {
          enabled: true,
        },
        vat_percentage: undefined,
        vat_category_code: undefined,
        name: [
          {
            lang: 'en',
            value: 'Value 1',
            verified: true,
          },
        ],
        visible_to_courier: false,
        visible_to_merchant_app: true,
        id: 'EXAMPLE_OPTION_VALUE_ID (not required)',
        price: 0,
      },
      {
        enabled: {
          enabled: true,
        },
        vat_percentage: undefined,
        vat_category_code: undefined,
        name: [
          {
            lang: 'en',
            value: 'Value 2',
            verified: true,
          },
        ],
        visible_to_courier: false,
        visible_to_merchant_app: true,
        id: 'EXAMPLE_OPTION_VALUE_ID (not required)',
        price: 0,
      },
      {
        enabled: {
          enabled: true,
        },
        vat_percentage: undefined,
        vat_category_code: undefined,
        name: [
          {
            lang: 'en',
            value: 'Value 3',
            verified: true,
          },
        ],
        visible_to_courier: false,
        visible_to_merchant_app: true,
        id: 'EXAMPLE_OPTION_VALUE_ID (not required)',
        price: 0,
      },
    ],
  },
  {
    id: 'EXAMPLE_OPTION_TWO',
    name: [
      {
        lang: 'en',
        value: 'EXAMPLE_OPTION_TWO',
        verified: true,
      },
    ],
    scope: {
      id: 'SCOPE',
      type: 'selection',
    },
    version: {
      author: {
        id: 'OFFERING_TEAM',
        kind: 'other',
      },
      created_at: { $date: 1691679028 },
      number: 1,
    },
    default_value_index: 0,
    type: 'choice',
    external_id: undefined,
    values: [
      {
        enabled: {
          enabled: true,
        },
        vat_percentage: undefined,
        vat_category_code: undefined,
        name: [
          {
            lang: 'en',
            value: 'Value 1',
            verified: true,
          },
        ],
        visible_to_courier: false,
        visible_to_merchant_app: true,
        id: 'EXAMPLE_OPTION_VALUE_ID',
        price: 0,
      },
      {
        enabled: {
          enabled: true,
        },
        vat_percentage: undefined,
        vat_category_code: undefined,
        name: [
          {
            lang: 'en',
            value: 'Value 2',
            verified: true,
          },
        ],
        visible_to_courier: false,
        visible_to_merchant_app: true,
        id: 'EXAMPLE_OPTION_VALUE_ID (not required)',
        price: 0,
      },
    ],
  },
];

export const categorySample: SelectionCategory[] = [
  {
    id: 'EXAMPLE_CAT_ONE',
    name: [
      {
        lang: 'en',
        value: 'EXAMPLE_CAT_ONE',
        verified: true,
      },
    ],
    scope: {
      id: 'SCOPE',
      type: 'brand',
    },
    version: {
      author: {
        id: 'OFFERING_TEAM',
        kind: 'other',
      },
      number: 1,
      created_at: '2023-12-13T10:00:00Z',
      updated_at: '2023-12-20T14:44:34Z',
    },
    description: [
      {
        lang: 'en',
        value: 'category description',
        verified: true,
      },
    ],
  },
  {
    id: 'EXAMPLE_CAT_TWO',
    name: [
      {
        lang: 'en',
        value: 'EXAMPLE_CAT_TWO',
        verified: true,
      },
    ],
    scope: {
      id: 'SCOPE',
      type: 'brand',
    },
    version: {
      author: {
        id: 'OFFERING_TEAM',
        kind: 'other',
      },
      number: 1,
      created_at: '2023-12-13T10:00:00Z',
      updated_at: '2023-12-20T14:44:34Z',
    },
    description: [
      {
        lang: 'en',
        value: 'category description',
        verified: true,
      },
    ],
  },
];
